import { render, staticRenderFns } from "./ProductionHome.vue?vue&type=template&id=0c3fbf0d&scoped=true&"
import script from "./ProductionHome.vue?vue&type=script&lang=js&"
export * from "./ProductionHome.vue?vue&type=script&lang=js&"
import style0 from "./ProductionHome.vue?vue&type=style&index=0&id=0c3fbf0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fbf0d",
  null
  
)

export default component.exports